import React from "react";
import {
    ButtonIconCopyClipboard,
    ButtonIconEdit,
    SelectField,
} from "../../../../Components/Inputs";
import {HtmlDisplay} from "../../../../Components/Display";
import {APH_LOAN_STATUS_LIST} from "./aphLoanConstants";
import {truncateString} from "../../../../Utilities/commonUtilities";
import {convertToCurrencyFormat} from "./aphLoanUtility";
import {AphLoanItem} from "./aphLoan.types";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface AphLoanRowProps {
    aphLoanItem: AphLoanItem;
    canManageAphLoans: boolean;
    handleCopyAddressToClipboard: (item: AphLoanItem) => Promise<void>;
    handleOpenEditDialog: (event: React.MouseEvent<HTMLElement>, item: AphLoanItem) => void;
    handleUpdateAphLoanStatus: (itemId: string, status: string | number) => void;
}

export const AphLoanRow = ({
                               aphLoanItem,
                               canManageAphLoans,
                               handleCopyAddressToClipboard,
                               handleOpenEditDialog,
                               handleUpdateAphLoanStatus
                           }: AphLoanRowProps) => {

    const handleAphLoanStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        handleUpdateAphLoanStatus(aphLoanItem.aphLoanItemId, event.target.value);
    };

    return (
        <tr id={aphLoanItem.aphLoanItemId}>
            <td>
                {aphLoanItem.dateCreatedFormatted}
            </td>
            <td>
                {aphLoanItem.aphCatalogItemTitle}
            </td>
            <td>
                {convertToCurrencyFormat(aphLoanItem.aphCatalogItemCost)}
            </td>
            <td>
                {aphLoanItem.patronFullName}
            </td>
            <td>
                {aphLoanItem.districtName}
            </td>
            <td>
                {aphLoanItem.organization}
            </td>
            <td>
                {aphLoanItem.shippingLocationName}
            </td>
            <td>
                {aphLoanItem.studentFullName}
            </td>
            <td>
                {aphLoanItem.aphCatalogNumber}
            </td>
            <td>
                {
                    canManageAphLoans ?
                        <SelectField
                            hideLabel
                            includeDefaultOption={false}
                            label={`APH Loan Status for ${aphLoanItem.aphCatalogItemTitle}`}
                            name={`aph-loan-status-${aphLoanItem.aphLoanItemId}`}
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleAphLoanStatusChange(event)}
                            options={APH_LOAN_STATUS_LIST}
                            value={aphLoanItem.aphLoanStatus}
                        />
                        :
                        <HtmlDisplay
                            html={APH_LOAN_STATUS_LIST.find((f: ListItem) => f.value === aphLoanItem.aphLoanStatus)?.text || ``}
                            name={`loan-aph-status-${aphLoanItem.aphLoanItemId}`}
                        />
                }
            </td>
            <td>
                {truncateString(aphLoanItem.aphLoanNotes)}
            </td>
            <td className={`align-center`}>
                {
                    canManageAphLoans &&
                    <ButtonIconEdit
                        inputDescription={`for ${aphLoanItem.aphCatalogItemTitle}`}
                        onClick={(event) => event && handleOpenEditDialog(event, aphLoanItem)}
                    />
                }
                <ButtonIconCopyClipboard
                    inputDescription={`for ${aphLoanItem.aphCatalogItemTitle}`}
                    onClick={async () => await handleCopyAddressToClipboard(aphLoanItem)}
                />
            </td>
        </tr>
    );
};